import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { act } from 'react-dom/test-utils';

interface LayoutDataState {
  userFormData: any;
  submitButtonLoading: boolean;
  error: string | null;
  fieldData: any;
  formSubmitSuccess: boolean;
  // login states
  loginButtonLoading: boolean;
  loginError: string | null;
  loginSuccess: boolean;
  // generate link states
  generateLinkButtonLoading: boolean;
  generateLinkError: string | null;
  generateLinkData:any;
  generateLinkSuccess: boolean;
  // get customer form data
  getCustomerFormData: any;
  getCustomerFormDataLoading: boolean;
  getCustomerFormDataError: boolean;

  // validated business reg number
  validateBRLoading: boolean;
  validatedBusinessRegNumber: any;

  //get prefered partner dropdown
  prefredPartnerData: any[];
  getPrefredPartnerDataLoading: boolean;
  getPrefredPartnerDataError: boolean;

  // validated applicant email
  validateApplicantEmailLoading: boolean;
  validatedApplicantEmail: boolean;
  validatedApplicantEmailError: string;

  //get account type dropdown
  tenantAccountTypes: any[];
  getTenantAccountTypesLoading: boolean;
  getTenantAccountTypesError: boolean;

}

const initialState: LayoutDataState = {
  userFormData: {},
  submitButtonLoading: false,
  error: null,
  fieldData: null,
  formSubmitSuccess: false,
  // login states
  loginButtonLoading: false,
  loginError: null,
  loginSuccess: false,
  // generate link states
  generateLinkButtonLoading: false,
  generateLinkError: null,
  generateLinkData: '',
  generateLinkSuccess: false,
  // get customer form data
  getCustomerFormData: {},
  getCustomerFormDataLoading: false,
  getCustomerFormDataError: false,

  // validated business reg number
  validateBRLoading: false,
  validatedBusinessRegNumber: null,

  //prefered partner dropdown
  prefredPartnerData: [],
  getPrefredPartnerDataLoading: false,
  getPrefredPartnerDataError: false,

  // validated applicant email
  validateApplicantEmailLoading: false,
  validatedApplicantEmail: false,
  validatedApplicantEmailError: '',

  //get account type dropdown
  tenantAccountTypes: [],
  getTenantAccountTypesLoading: false,
  getTenantAccountTypesError: false,
};

const homeDataSlice = createSlice({
  name: 'homeData',
  initialState,
  reducers: {
    // submit new field
    userRegisterDataChange: (state, action: PayloadAction<any>) => {
      state.userFormData = action.payload;
    },

    // reset formSubmitSuccess
    resetFormSuccessStates: state => {
      state.formSubmitSuccess = false;
    },
    // submit new field
    formSubmitRequest: (state, action: PayloadAction<any>) => {
      state.submitButtonLoading = true;
      state.error = null;
      state.formSubmitSuccess = false;
    },
    formSubmitSuccess: (state, action: PayloadAction<any>) => {
      state.submitButtonLoading = false;
      state.fieldData = null;
      state.formSubmitSuccess = true;
    },
    formSubmitFailed: (state, action: PayloadAction<string>) => {
      state.submitButtonLoading = false;
      state.error = action.payload;
      state.formSubmitSuccess = false;
    },
    // user login
    userLoginRequest: (state, action: PayloadAction<any>) => {
      state.loginButtonLoading = true;
      state.loginError = null;
      state.loginSuccess = false;
    },
    userLoginSuccess: (state, action: PayloadAction<any>) => {
      state.loginButtonLoading = false;
      state.loginError = null;
      state.loginSuccess = true;
    },
    userLoginFailed: (state, action: PayloadAction<string>) => {
      state.loginButtonLoading = false;
      state.loginError = action.payload;
      state.loginSuccess = false;
    },
    // generate link
    generateLinkRequest: (state, action: PayloadAction<any>) => {
      state.generateLinkButtonLoading = true;
      state.generateLinkError = null;
      state.generateLinkSuccess = false;
      state.generateLinkData = '';
    },
    generateLinkSuccess: (state, action: PayloadAction<any>) => {
      state.generateLinkButtonLoading = false;
      state.generateLinkError = null;
      state.generateLinkSuccess = true;
      state.generateLinkData = action.payload;
    },
    generateLinkFailed: (state, action: PayloadAction<string>) => {
      state.generateLinkButtonLoading = false;
      state.generateLinkError = action.payload;
      state.generateLinkSuccess = false;
      state.generateLinkData = '';
    },
    generateLinkClear: state => {
      state.generateLinkButtonLoading = false;
      state.generateLinkError = null;
      state.generateLinkSuccess = false;
      state.generateLinkData = '';
    },
    // get customer form data
    getCustomerFormDataRequest: (state, action: PayloadAction<any>) => {
      state.getCustomerFormDataLoading = true;
      state.getCustomerFormDataError = false;
    },
    getCustomerFormDataSuccess: (state, action: PayloadAction<any>) => {
      state.getCustomerFormData = action.payload;
      state.getCustomerFormDataLoading = false;
      state.getCustomerFormDataError = false;
    },
    getCustomerFormDataFailed: (state, action: PayloadAction<string>) => {
      state.getCustomerFormDataLoading = false;
      state.getCustomerFormDataError = true;
    },
    resetGetCustomerFromDataState: state => {
      state.getCustomerFormData = {};
      state.getCustomerFormDataLoading = false;
      state.getCustomerFormDataError = false;
    },

    //check business registration number
    getBusinessRegistrationNumberRequest: (
      state,
      action: PayloadAction<any>
    ) => {
      state.validateBRLoading = true;
    },
    getBusinessRegistrationNumberSuccess: (
      state,
      action: PayloadAction<any>
    ) => {
      state.validatedBusinessRegNumber = action.payload;
      state.validateBRLoading = false;
      state.getCustomerFormDataLoading = false;
      state.getCustomerFormDataError = false;
    },
    getBusinessRegistrationNumberFailed: (
      state,
      action: PayloadAction<string>
    ) => {
      state.getCustomerFormDataLoading = false;
      state.getCustomerFormDataError = true;
    },

    //get prefered partner
    getPreferdPartnerDataRequest: (state) => {
      state.getPrefredPartnerDataLoading = true;
      state.getPrefredPartnerDataError = false;
    },
    getPreferedPartnerDataSuccess: (state, action: PayloadAction<any>) => {
      state.prefredPartnerData = action?.payload;
      state.getPrefredPartnerDataLoading = false;
      state.getPrefredPartnerDataError = false;
    },
    getPreferdPartnerDataFailed: (state, action: PayloadAction<string>) => {
      state.getPrefredPartnerDataLoading = false;
      state.getPrefredPartnerDataError = true;
    },

    //check applicant email
    getApplicantEmailValidateRequest: (state, action: PayloadAction<any>) => {
      state.validateApplicantEmailLoading = true;
    },
    getValidApplicantEmailSuccess: (state, action: PayloadAction<any>) => {
      state.validatedApplicantEmail = action.payload;
      state.validateApplicantEmailLoading = false;
      state.validatedApplicantEmailError = '';
    },
    getValidApplicantEmailFailed: (state, action: PayloadAction<string>) => {
      state.validateApplicantEmailLoading = false;
      state.validatedApplicantEmailError = action.payload;
    },
  //get account type
    getTenantAccountTypesRequest: (state) => {
      state.getTenantAccountTypesLoading = true;
      state.getTenantAccountTypesError = false;
    },
    getTenantAccountTypesSuccess: (state, action: PayloadAction<any>) => {
      state.tenantAccountTypes = action.payload;
      state.getTenantAccountTypesLoading = false;
    },
    getTenantAccountTypesFailed: (state, action: PayloadAction<string>) => {
      state.getTenantAccountTypesLoading = false;
      state.getTenantAccountTypesError = true;
    },


  },
});

export const {
  userRegisterDataChange,
  resetFormSuccessStates,
  formSubmitRequest,
  formSubmitSuccess,
  formSubmitFailed,
  userLoginRequest,
  userLoginSuccess,
  userLoginFailed,
  generateLinkRequest,
  generateLinkSuccess,
  generateLinkFailed,
  generateLinkClear,
  getCustomerFormDataRequest,
  getCustomerFormDataSuccess,
  getCustomerFormDataFailed,
  resetGetCustomerFromDataState,
  getBusinessRegistrationNumberRequest,
  getBusinessRegistrationNumberSuccess,
  getBusinessRegistrationNumberFailed,
  getApplicantEmailValidateRequest,
  getValidApplicantEmailSuccess,
  getValidApplicantEmailFailed,

  //prefredpartner dropdown data
  getPreferdPartnerDataRequest,
  getPreferedPartnerDataSuccess,
  getPreferdPartnerDataFailed,
  //tenant account type dropdown
  getTenantAccountTypesRequest,
  getTenantAccountTypesSuccess,
  getTenantAccountTypesFailed
} = homeDataSlice.actions;

export default homeDataSlice.reducer;
